<ul class="adc-list" *ngIf="type != 'multiLine'" ngClass="{{ data.customClass }}">
    <li *ngFor="let i of data.items"><span class="adc-mr10"></span>{{i.itemLabel}}</li>
</ul>

<ul class="adc-list" *ngIf="type == 'multiLine'" ngClass="{{ data.customClass }}">
    <li class="adc-d-flex adc-justify-content-between" *ngFor="let i of data.items">
        <span>{{i.itemLabel}}</span>
        <span style="float: right;" class="adc-align-self-center">
            <!-- <mat-icon class="adc-mt2">home</mat-icon> -->
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20px" class="adc-mt2"><title>home-outline</title><path d="M12 5.69L17 10.19V18H15V12H9V18H7V10.19L12 5.69M12 3L2 12H5V20H11V14H13V20H19V12H22" /></svg>
        </span>
    </li>
</ul>